import React from 'react';
import FoodCourtTitleSkeleton from "./skeleton/FoodCourtTitleSkeleton";
import { useSelector } from "react-redux";
import languages from "languages/languages";
import styles from "screens/FoodCourt/Home/Home.module.css";

function FoodCourtTitle(props) {
    const langState = useSelector((state) => state.language.lang);
    const {loading} = props;
    if(loading) {
        return <FoodCourtTitleSkeleton />
    }

    return(
        <>
            <h1 className={styles.title}>{languages[langState]["Phố ẩm thực"]}</h1>
        </>
    );
}
export default FoodCourtTitle;